export default __webpack_public_path__ + "static/media/undraw_profile_data_re_v81r.bcfee360.svg";